import { Maybe, rd, RemoteData } from '@passionware/monads';
import {
  withWorkspaceScoping,
  WithWorkspaceScoping
} from 'v5/api/_common/query/workspace-scoping';
import {
  withTeamScoping,
  WithTeamScoping
} from 'v5/api/_common/query/team-scoping';
import { ResolvedAppScope } from '../appScope.types';
import { workspaceScopingFromResolvedScope } from './workspaceScopingFromResolvedScope';
import { teamScopingFromResolvedScope } from './teamScopingFromResolvedScope';

export type WithProductionScoping<T> = WithTeamScoping<WithWorkspaceScoping<T>>;

/**
 * Applies production list filters from resolved app scope (URL-derived):
 * - org → no workspace/team filter
 * - workspace → `enterprise_workspace_id`
 * - team → workspace + `enterprise_team_id`
 */
export function useWithProductionScoping<T>(
  scopeRd: RemoteData<ResolvedAppScope>,
  searchQuery: T
): Maybe<WithProductionScoping<T>> {
  return rd.tryMap(scopeRd, scope =>
    withTeamScoping(
      withWorkspaceScoping(
        searchQuery,
        workspaceScopingFromResolvedScope(scope)
      ),
      teamScopingFromResolvedScope(scope)
    )
  );
}
